var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bkwishlist" },
    [
      _vm.isLoggedIn
        ? [
            _c(
              "a",
              {
                staticClass: "wishlist-icon-list addToWishlistCategory",
                class: {
                  active: _vm.isVariationInWishList(),
                  loading: !_vm.isInitiallyLoaded || _vm.wishlistIsLoading,
                },
                on: {
                  click: function ($event) {
                    return _vm.openAddToWishlist()
                  },
                },
              },
              [_c("i", { staticClass: "fa fas fa-heart" })]
            ),
          ]
        : [
            _c(
              "a",
              {
                staticClass: "wishlist-icon-list addToWishlistCategory",
                class: {
                  loading: !_vm.isInitiallyLoaded || _vm.wishlistIsLoading,
                },
                attrs: { href: "#login", "data-toggle": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.loadRegistrationModal()
                  },
                },
              },
              [_c("i", { staticClass: "fa fas fa-heart" })]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }